import { FILTER } from '../../constants/actionTypes';
import serializeUrl from '../../utils/serialize_url';
import { routes } from '../../constants/config';
import { getSharedParams } from '../shared/utils';

const initialState = {
  type: 'user',
  page: 1,
  groups: [],
  role: null,
  query: '',
  date: null,
  manager: null,
  sort: {
    column: 'name',
    direction: 'asc',
  },
  perPage: 10,
  activeGroup: null,
  editing: false,
  myOrganization: false,
};

const getParams = ({
  page,
  type,
  query,
  groups,
  date,
  role,
  manager,
  sort,
  perPage,
  activeGroup,
  editing,
  myOrganization,
}) => {
  const params = getSharedParams({
    page,
    query,
    date,
    sort,
    perPage,
    initialState,
    editing,
  });
  if (!_.isEmpty(groups)) params.groups = groups;
  if (!_.isNull(role)) params.role = role;
  if (myOrganization && _.isNull(activeGroup)) {
    params.myOrganization = true;
  }
  if (!_.isNull(manager)) params.manager = manager;
  if (type !== 'user') params.type = type;
  if (!_.isNull(activeGroup)) params.activeGroup = activeGroup;
  return params;
};

const getNewState = (state, changes) => {
  const newState = _.assign({}, state, changes);
  const { query, groups, date, role, manager } = newState;
  newState.isActive = [
    _.isEmpty(query),
    _.isEmpty(groups),
    _.isNull(role),
    _.isNull(manager),
    _.isEmpty(date),
  ].some(filter => !filter);
  newState.page = (!!changes && changes.page) || 1;
  newState.url = serializeUrl(routes.PEOPLE, getParams(newState));
  return newState;
};

export const currentFilter = (state, action) => {
  switch (action.type) {
    case FILTER.UPDATE.PAGE:
      return getNewState(state, {
        page: action.page,
      });

    case FILTER.UPDATE.TYPE:
      return getNewState(state, {
        type: action.contentType,
      });

    case FILTER.UPDATE.DATE:
      return getNewState(state, {
        date: action.date,
      });

    case FILTER.UPDATE.QUERY:
      return getNewState(state, {
        query: action.query,
      });

    case FILTER.UPDATE.GROUPS:
      return getNewState(state, {
        groups: action.groups,
      });

    case FILTER.UPDATE.ACTIVE_GROUP:
      return getNewState(state, {
        activeGroup: action.group,
      });

    case FILTER.UPDATE.EDITING:
      return getNewState(state, {
        editing: action.editing,
      });

    case FILTER.UPDATE.ROLE:
      return getNewState(state, {
        role: action.roleId,
      });

    case FILTER.UPDATE.MANAGER:
      return getNewState(state, {
        manager: action.manager,
      });

    case FILTER.UPDATE.MY_ORGANIZATION:
      return getNewState(state, {
        myOrganization: action.myOrganization,
      });

    case FILTER.UPDATE.PER_PAGE:
      return getNewState(state, {
        perPage: action.perPage,
      });

    case FILTER.UPDATE.ALL:
      return getNewState(state, action.filter);

    case FILTER.CLEAR:
      return getNewState(
        state,
        _.merge({}, initialState, {
          type: state.type === 'group' ? 'group' : initialState.type,
          sort: state.sort,
          perPage: state.perPage,
          activeGroup: state.activeGroup,
        }),
      );

    case FILTER.SORT: {
      let direction = action.sortType === 'numeric' ? 'desc' : 'asc';
      if (state.sort.column === action.sortOn) {
        direction = state.sort.direction === 'asc' ? 'desc' : 'asc';
      }
      return getNewState(state, {
        sort: {
          column: action.sortOn,
          direction,
        },
      });
    }

    default:
      return getNewState(initialState, state);
  }
};
